import script from "./VerificationResults.vue?vue&type=script&setup=true&lang=js"
export * from "./VerificationResults.vue?vue&type=script&setup=true&lang=js"

import "./VerificationResults.vue?vue&type=style&index=0&id=efbb723a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-efbb723a"]])

export default __exports__